import React from 'react';
import { Badge, Button } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

interface CartFabProps {
  count: number;
  onClick: () => void;
}

/**
 * Floating cart button for mobile product browsing (issue #125).
 *
 * On mobile the header's nav — and with it the Cart entry — collapses into the
 * hamburger menu, so checking the cart while browsing takes two taps and hides
 * the products behind the menu drawer. This puts the cart back within thumb
 * reach at the bottom-right of the screen.
 *
 * It opens the same side panel as the header's Cart (issue #121) rather than
 * routing to /cart, so the shopper keeps their place in the product list.
 *
 * Visibility is CSS-driven (`.dasoon-cart-fab`): hidden by default and shown
 * only under 768px — the same breakpoint that hides the desktop nav, so the
 * button appears exactly when the header's Cart entry disappears.
 */
const CartFab: React.FC<CartFabProps> = ({ count, onClick }) => (
  <div className="dasoon-cart-fab">
    <Badge count={count} showZero={false} offset={[-6, 6]}>
      <Button
        type="primary"
        shape="circle"
        icon={<ShoppingCartOutlined />}
        onClick={onClick}
        aria-label={count > 0 ? `Open cart, ${count} items` : 'Open cart'}
      />
    </Badge>
  </div>
);

export default CartFab;
